import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Form } from 'react-bootstrap';

class ClienteConfigForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {};
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (event) => {
    const { name, checked } = event.target;
    const { data } = this.props;

    this.props.onFormDataChange({
      data: {
        ...data,
        config: {
          ...data.config,
          [name]: checked,
        },
      },
      step: this.props.step,
      isValid: true,
    });
  };

  render() {
    const {
      data: { config = {} },
    } = this.props;

    return (
      <Form>
        <Form.Group controlId="pdf_sucursal">
          <Form.Check
            type="checkbox"
            name="pdf_sucursal"
            label="Mostrar sucursal en PDF"
            checked={config.pdf_sucursal || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>
      </Form>
    );
  }
}

export default ClienteConfigForm;
